import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../html/checkbox'
import { Element } from '../../../../html/element'
import { SelectCustom } from '../../../../selectCustom'
import { SCROLL_COMPONENT_IDS } from '../../../constant'
import {
  changeListSelectedListBusinessSize,
  selectDataByTypeMoney,
  selectListSelectedBusinessSize,
} from '../../../store/sliceBusinessSize'
import { LayoutContent } from '../layoutContent'

export const BusinessSize = () => {
  const dispatch = useDispatch()
  const dataBusinessSizeByMoney = useSelector(selectDataByTypeMoney)
  const listSelected = useSelector(selectListSelectedBusinessSize)

  //Actions
  const handleChoose = (value) => {
    dispatch(changeListSelectedListBusinessSize(value))
  }

  return (
    <div>
      <div style={{ width: 'fit-content' }}>
        <SelectCustom
          renderActiveItem={() => (
            <Element elementName="p" style={{ whiteSpace: 'nowrap' }}>
              <Translate value="library.filterSetting.SIZE_SELECT" />
            </Element>
          )}
          data={[{}]}
          style={{ minWidth: 240, width: 'fit-content', minHeight: 28 }}
          scrollId={SCROLL_COMPONENT_IDS}
        >
          {() => (
            <Element style={{ padding: 12, backgroundColor: '#FFFFFF' }}>
              {dataBusinessSizeByMoney?.map((item) => (
                <DropdownItem
                  key={item?.value}
                  item={item}
                  listSelected={listSelected}
                  handleChoose={handleChoose}
                />
              ))}
            </Element>
          )}
        </SelectCustom>
      </div>

      {!!listSelected?.length && (
        <Element
          elementName="p"
          style={{
            fontStyle: 'italic',
            padding: '4px 0',
          }}
        >
          <Translate
            value={`library.main.${
              !listSelected?.length || listSelected?.length < 2
                ? 'ITEM_SINGLE_SELECT'
                : 'ITEM_SELECT'
            }`}
            count={listSelected?.length}
          />
        </Element>
      )}

      <LayoutContent data={listSelected} onClickDelete={handleChoose} />
    </div>
  )
}

export const DropdownItem = ({ item, handleChoose, listSelected }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onClick={(e) => {
        handleChoose(item)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      className="cursorPointer"
    >
      <Element
        style={{
          borderBottom: '1px solid #D5D5D5',
        }}
      >
        <Checkbox
          title={item.label}
          checked={listSelected.map((item) => item.value).includes(item.value)}
          onChange={() => {
            handleChoose(item)
          }}
          isCheckOnClickText
          styleIcon={{ fontSize: 15, paddingRight: 8 }}
          style={{ padding: '6px 0' }}
        />
      </Element>
    </Element>
  )
}
